import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import getCroppedImg from "../utils/CropImage";

const ImageCropUpload = ({ onCropped }) => {
    const [image, setImage] = useState(null);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [croppedImage, setCroppedImage] = useState(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => setImage(reader.result);
            reader.readAsDataURL(file);
        }
    };

    const onCropComplete = useCallback((_, croppedPixels) => {
        setCroppedAreaPixels(croppedPixels);
    }, []);

    const handleCrop = useCallback(async () => {
        const cropped = await getCroppedImg(image, croppedAreaPixels);
        setCroppedImage(cropped);
        if (onCropped) onCropped(cropped);
    }, [image, croppedAreaPixels]);

    return (
        <div className="space-y-6 p-4 max-w-md mx-auto bg-[#F7F7F7]">
            <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                className="block w-full text-sm text-[#6B7280] file:mr-4 file:py-2 file:px-4
                   file:rounded-full file:border-0
                   file:text-sm file:font-semibold
                   file:bg-[#7070f5] file:text-[white]
                   hover:file:bg-[#4141ed] 
                   hover:file:text-[white]"
            />

            {image && (
                <>
                    <div className="relative w-full h-72 bg-gray-800 rounded overflow-hidden">
                        <Cropper
                            image={image}
                            crop={crop}
                            zoom={zoom}
                            aspect={1}
                            onCropChange={setCrop}
                            onZoomChange={setZoom}
                            onCropComplete={onCropComplete}
                        />
                    </div>

                    <div className="flex justify-between space-x-4">
                        <div className="flex flex-col space-y-2 w-[65%]">
                            <label className="text-sm text-gray-600">Zoom</label>
                            <input
                                type="range"
                                min={1}
                                max={3}
                                step={0.1}
                                value={zoom}
                                onChange={(e) => setZoom(e.target.value)}
                                className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-600"
                            />
                        </div>

                        <div className="flex flex-col space-y-2 w-[1/3]">
                            <button
                                onClick={handleCrop}
                                className="bg-[#7070f5] text-[white] font-semibold px-4 py-2 rounded hover:bg-[#4141ed] transition"
                            >
                                Crop & Use
                            </button>
                        </div>
                    </div>
                </>
            )}

            {croppedImage && (
                <div className="mt-4 flex flex-col items-center">
                    <p className="text-sm text-gray-600 mb-1">Preview:</p>
                    <img src={croppedImage} alt="Cropped" className="rounded border shadow-md w-32 h-32 object-cover" />
                </div>
            )}
        </div>
    );
};

export default ImageCropUpload;
